import { useTranslation } from 'react-i18next';
import { AlertTriangle, CircleOff } from 'lucide-react';
import { Alert, AlertDescription, EntityIcon } from '@bliks-io/ui';

export function SuccessorNoneBody() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-3 rounded-xl border border-line bg-white p-4">
        <EntityIcon icon={<CircleOff className="h-5 w-5" />} tone="neutral" size={40} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground">
            {t('entityPicker.successor.none.cardTitle')}
          </p>
          <p className="mt-1 text-sm text-fg-secondary">
            {t('entityPicker.successor.none.cardBody')}
          </p>
        </div>
      </div>

      <Alert colorScheme="warning">
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription>{t('entityPicker.successor.none.warning')}</AlertDescription>
      </Alert>
    </div>
  );
}
